import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { subscribeToBanquetOwnerAuth } from "../services/banquetOwnerAuthService.js";
import { canAccessSuperAdmin } from "../services/banquetAccessRules.js";
import ChangePasswordScreen from "./ChangePasswordScreen.jsx";

export default function SuperAdminProtectedRoute({ children }) {
  const location = useLocation();
  const [authState, setAuthState] = useState({
    isLoading: true,
    owner: null,
  });

  useEffect(() => {
    const unsubscribe = subscribeToBanquetOwnerAuth((owner) => {
      setAuthState({
        isLoading: false,
        owner,
      });
    });

    return unsubscribe;
  }, []);

  const noindexMeta = <meta name="robots" content="noindex, nofollow" />;

  if (authState.isLoading) {
    return (
      <>
        {noindexMeta}
        <div className="flex min-h-screen items-center justify-center bg-[#f5f7f4] px-4">
          <div className="rounded-3xl border border-slate-200 bg-white px-8 py-10 text-center shadow-sm">
            <p className="text-sm font-semibold uppercase tracking-[0.24em] text-emerald-600">Super Admin</p>
            <h1 className="mt-3 text-2xl font-semibold text-slate-900">Checking admin access</h1>
            <p className="mt-2 text-sm text-slate-600">Verifying super admin role from Firebase Auth and Firestore.</p>
          </div>
        </div>
      </>
    );
  }

  if (!canAccessSuperAdmin(authState.owner)) {
    return <Navigate to="/banquet-owner/login" replace state={{ from: location }} />;
  }

  if (authState.owner.mustChangePassword) {
    return (
      <>
        {noindexMeta}
        <ChangePasswordScreen
          onPasswordChanged={() =>
            setAuthState((current) => ({
              ...current,
              owner: { ...current.owner, mustChangePassword: false },
            }))
          }
        />
      </>
    );
  }

  return (
    <>
      {noindexMeta}
      {children}
    </>
  );
}
